// @flow
import { DAMM_RED } from '../../../../../theme/colors.js'

export const DEFAULT_FONT_SIZE = 16
export const INFO_PANEL_FONT_SIZE = 12
export const POWERED_BY_FONT_SIZE = 10

export default {
  container: {
    paddingTop: 16
  },
  anchor: (color: string) => ({
    textDecoration: 'none',
    color
  }),
  category: {
    cursor: 'pointer',
    width: 'fit-content'
  },
  categoryTitle: (color: string, fontSize: number) => ({
    color,
    fontSize,
    fontWeight: 'bold'
  }),
  text: (isActive: boolean, color: string, fontSize: number) => ({
    color: isActive ? DAMM_RED : color,
    cursor: 'pointer',
    fontSize
  })
}
